import { render, staticRenderFns } from "./UpSelect.vue?vue&type=template&id=67832241&scoped=true"
import script from "./UpSelect.vue?vue&type=script&lang=js"
export * from "./UpSelect.vue?vue&type=script&lang=js"
import style0 from "./UpSelect.vue?vue&type=style&index=0&id=67832241&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67832241",
  null
  
)

export default component.exports